module.exports = __webpack_public_path__ + "img/great.2842e30f.png";